import { ApolloClient, HttpLink, from, InMemoryCache } from '@apollo/client';
import { onError } from '@apollo/client/link/error';

const ProjectsAPI = require('./config').projects_api_server;
const FormsAPI = require('./config').forms_graphql_server;
const VendorsAPI = require('./config').vendors_api_server;

const defaultOptions = {
	watchQuery: {
		fetchPolicy: 'no-cache',
	},
	query: {
		fetchPolicy: 'no-cache',
	},
};

const errorLink = onError(({ graphQLErrors, networkError }) => {
	if (graphQLErrors) {
		if (graphQLErrors[0].code === 401) {
			//onUserKickedOut();
		}
	}
});

// Cache ApolloClient instances per type+vendorID to reuse connections
const clientCache = {};

const getClient = (type, vendorID) => {
	const key = `${type || 'default'}:${vendorID}`;
	if (!clientCache[key]) {
		const httpLink = new HttpLink({
			uri: `${
				type == 'forms' ? FormsAPI : type == 'vendors' ? VendorsAPI : ProjectsAPI
			}/${vendorID}/graphql`,
		});

		clientCache[key] = new ApolloClient({
			cache: new InMemoryCache(),
			defaultOptions,
			connectToDevTools: false,
			link: from([errorLink, httpLink]),
		});
	}
	return clientCache[key];
};

const Service = {
	query: async (query, variables, vendorID, usertoken, type = null) => {
		const apolloClient = getClient(type, vendorID);

		return await apolloClient
			.query({
				query,
				variables,
				context: {
					headers: {
						authorization: usertoken ? `Bearer ${usertoken}` : '',
					},
				},
			})
			.then((res) => {
				return [true, res];
			})
			.catch((err) => {
				return [false, err];
			});
	},

	mutation: async (mutation, variables, vendorID, usertoken, type = null, subType = null) => {
		const apolloClient = getClient(type, vendorID);

		return await apolloClient
			.mutate({
				mutation,
				variables,
				context: {
					headers: {
						authorization: usertoken ? `Bearer ${usertoken}` : '',
					},
				},
			})
			.then((res) => {
				return [true, res];
			})
			.catch((err) => {
				return [false, err];
			});
	},
};

const onUserKickedOut = async (res, url) => {
	localStorage.clear('usertoken');
	window.open('https://vendors.huemn.com');
};

export default Service;
